export default "__VITE_ASSET__CE$KcXH8__"